import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { VideoBanner } from './core/video-banner.model';
import { BehaviorSubject, Subscription, switchMap } from 'rxjs';
import { CmsComponentData } from '@spartacus/storefront';
import { VideoBannerService } from './core/video-banner.service';
import { WindowRef } from '@spartacus/core';

@Component({
  selector: 'video-banner',
  templateUrl: './video-banner.component.html',
  styleUrl: './video-banner.component.scss',
  standalone: false,
})
export class VideoBannerComponent implements OnInit, OnDestroy {
  @ViewChild('videoContainer') videoContainer!: ElementRef;

  items$ = new BehaviorSubject<VideoBanner[]>([]);
  engine: any;
  interval = 17000;
  subscription = new Subscription();

  constructor(
    private componentData: CmsComponentData<any>,
    private videoBannerService: VideoBannerService,
    private winref: WindowRef,
  ) {}

  ngOnInit(): void {
    this.populateComponent();
  }

  ngOnDestroy(): void {
    this.engine && clearInterval(this.engine);
  }

  populateComponent() {
    this.winref.isBrowser() &&
      this.subscription.add(
        this.componentData.data$.pipe(switchMap(data => this.videoBannerService.normalize(data))).subscribe(data => {
          this.items$.next(data);
          this.rotateBanner();
        }),
      );
  }

  rotateBanner() {
    clearInterval(this.engine);

    this.engine = setInterval(() => {
      const maxIndex = this.items$.getValue().length - 1;
      const $container = this.videoContainer;

      if ($container) {
        const $activeItem = $container.nativeElement.querySelector(`.js-video-item.is-active`) as HTMLDivElement;
        const activeIndex = parseInt($activeItem?.getAttribute(`data-index`) || `0`);
        const nextIndex = activeIndex + 1 <= maxIndex ? activeIndex + 1 : 0;

        this.playByIndex(nextIndex);
      }
    }, this.interval);
  }

  playByIndex(nextIndex: number) {
    clearInterval(this.engine);

    const clearAllElements = (selector: string) => {
      const $container = this.videoContainer;
      const $elements = $container.nativeElement.querySelectorAll(selector) as HTMLDivElement[];

      $elements.forEach($el => {
        $el.classList.remove('is-active');
      });
    };

    clearAllElements('.js-dot');
    clearAllElements('.js-video-item');

    const $container = this.videoContainer;
    const $nextDot = $container.nativeElement.querySelector(`.js-dot[data-index="${nextIndex}"]`) as HTMLButtonElement;
    const $nextVideo = $container.nativeElement.querySelector(
      `.js-video-item[data-index="${nextIndex}"]`,
    ) as HTMLDivElement;

    $nextVideo.classList.add(`is-active`);
    $nextDot.classList.add(`is-active`);

    this.rotateBanner();
  }

  onCanPlay(video: HTMLVideoElement): void {
    video.muted = true;

    if (video.muted) {
      video.play().catch(err => {
        // eslint-disable-next-line
        console.warn('Autoplay failed: ', err);
      });
    }
  }
}
